var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelPagesCrossSell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 192,
    viewBox: "0 0 128 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 192,
    fill: "#E0EEFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 52,
    r: 24,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.702 14c.39.388 1.02.388 1.41 0 .387-.39.387-1.02 0-1.41L7.845 6.295c-.392-.392-1.027-.392-1.42 0-.391.392-.391 1.027 0 1.42L12.703 14zm12.294 3.998c-.552 0-1 .448-1 1v3.588l-4.557-4.588c-.397-.397-1.042-.397-1.44 0-.397.398-.397 1.042 0 1.44l4.589 4.557h-3.589c-.552 0-1 .448-1 1s.448 1 1 1h5.997c.131-.002.26-.03.38-.08.244-.102.439-.296.54-.54.051-.12.078-.25.08-.38v-5.997c0-.552-.448-1-1-1zm.92-11.374c-.101-.244-.296-.439-.54-.54-.12-.051-.249-.078-.38-.08H19c-.552 0-1 .448-1 1s.448 1 1 1h3.589L6.296 24.284c-.19.188-.296.443-.296.71 0 .266.106.522.296.71.187.189.443.295.71.295.266 0 .521-.106.709-.296L23.997 9.412v3.589c0 .552.447 1 1 1 .551 0 .999-.448.999-1V7.004c-.002-.131-.029-.26-.08-.38z",
    transform: "translate(48 36)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEFF",
    d: "M4 0h120c2.21 0 4 1.79 4 4v12H0V4c0-2.21 1.79-4 4-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 8,
    r: 3,
    fill: "#25CF1B"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99C7FF",
    d: "M0 16.5L128 16.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3,
    fill: "#F20D5D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 3,
    fill: "#F9C206"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 8,
    x: 36,
    y: 4,
    fill: "#FFF",
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 144)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 32,
    fill: "#0072FF",
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.606 20c1.633 0 2.503-.852 2.503-2.01 0-1.076-.77-1.726-1.598-1.765v-.07c.757-.171 1.314-.708 1.314-1.563 0-1.09-.81-1.865-2.415-1.865h-2.912V20h3.108zm-.43-4.23h-1.14v-1.8h1.168c.682 0 1.07.352 1.07.877 0 .576-.47.924-1.098.924zm.114 2.973h-1.254V16.81h1.289c.739 0 1.197.426 1.197 1.026 0 .547-.373.906-1.232.906zm5.427 1.328c.82 0 1.41-.423 1.655-1.062h.056V20h1.453v-5.455h-1.513v3.133c.004.731-.497 1.115-1.04 1.115-.572 0-.941-.402-.945-1.044v-3.204H34.87v3.473c.004 1.275.75 2.053 1.847 2.053zm5.097 1.974c1.126 0 1.722-.575 2.031-1.456l2.12-6.036-1.601-.008-1.14 4.006h-.057l-1.13-4.006h-1.59l1.956 5.611-.088.231c-.2.511-.58.536-1.112.373l-.34 1.13c.216.092.567.155.95.155zM50.154 20v-3.153c.004-.704.423-1.115 1.034-1.115.607 0 .973.397.97 1.065V20h1.512v-3.473c0-1.271-.746-2.053-1.882-2.053-.81 0-1.396.398-1.64 1.034h-.065v-.963h-1.441V20h1.512zm6.962.107c1.655 0 2.684-1.133 2.684-2.813 0-1.69-1.03-2.82-2.684-2.82-1.655 0-2.685 1.13-2.685 2.82 0 1.68 1.03 2.813 2.685 2.813zm.007-1.172c-.764 0-1.154-.7-1.154-1.652 0-.951.39-1.654 1.154-1.654.75 0 1.14.703 1.14 1.654 0 .952-.39 1.652-1.14 1.652zM63.118 20l.938-3.43h.067l.938 3.43h1.601l1.481-5.455h-1.527l-.83 3.644h-.047l-.895-3.644h-1.502l-.88 3.665h-.05l-.845-3.665h-1.531L61.52 20h1.598z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 8,
    x: 14,
    y: 88,
    fill: "#338EFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 8,
    x: 14,
    y: 104,
    fill: "#99C7FF",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 8,
    x: 14,
    y: 120,
    fill: "#99C7FF",
    rx: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelPagesCrossSell);
export default __webpack_public_path__ + "static/media/illustrations-funnel-pages-cross-sell.9eaa1d9d.svg";
export { ForwardRef as ReactComponent };